export enum CompanyCategoryEnum {
    Food = "Food",
    Markets = "Markets"
}

export enum ProductTypeEnum {
    Perishable = "Perishable",
    Nonperishable = "Nonperishable",
    VirtualGood = "Virtual Good"
}

export enum CompanyFiltersFoodEnum { 
    foodOptions = "Food Options",
    timeOfDay = "Time of Day",
    quickSearch = "Quick Search"
}

export enum CompanyFiltersMarketsEnum { 
    marketOptions = "Markets Options"
}

export class CountryCodes {
    country: string;
    currencyCode: string;
    countryCode: string;
    phoneCode: string;

    constructor() {
        this.country = "";
        this.currencyCode = "";
        this.countryCode = "";
        this.phoneCode = "";
    }
}

export class UrlHandles {
    handle: string;
    createdOn: any;
    for: string;
    companyId: string;

    setForCompany(handle) {
        this.for = "company";
        this.createdOn = Date.now();
        this.handle = handle;
    }
}

export class Testimonial {
    description: string;
    title: string;
    whatsappNumber: any;

    constructor(obj) {
        this.description = obj.description;
        this.title = obj.title;
        this.whatsappNumber = obj.whatsappNumber;
    }
}

export class Product {
    title: string;
    description: string;
    image: string;
    testimonials: Array<Testimonial>;
    sellingUnit: string;
    sellingUnitType: string;
    pricePerUnit: number;
    quantity: number;
    createdOn: any;
    updatedOn: any;
    id: string;
    category: string;
    plu: number;
    currency: string;
    productType: string;

    constructor() {
        this.title = "";
        this.image = "";
        this.description = "";
        this.testimonials = new Array<Testimonial>();
        this.sellingUnitType = "";
        this.sellingUnit = "";
        this.pricePerUnit = 0.0;
        this.createdOn = null;
        this.updatedOn = null;
        this.quantity = 0;
        this.id = "";
        this.category = null;
        this.plu = null;
        this.currency = null;
        this.productType = "";
    }
}

export class ProductMaster {
    title: string;
    productID: string;
    category: string;
    companyID: string;
    plu: number;
    product: Product;

    constructor(product: Product, cid: string) {
        this.title = product.title;
        this.productID = product.id;
        this.category = product.category;
        this.companyID = cid;
        this.plu = product.plu;
    }
}

export class Follower {
    id: string;
    createdOn: number;

    constructor(id) {
        this.id = id;
        this.createdOn = Date.now();
    }
}

export class CompanyDetails {
    title: string;
    description: string;
    whatsappNumber: string;
    urlHandle: string;
    images: Array<string>;
    products: Array<Product>;
    addressLine1: string;
    addressLine2: string;
    city: string;
    country: string;
    postalCode: string;
    category: string;
    currency: string;
    companyType: string;
    active: boolean;
    activeTill: number;
    worth: number;
    createdOn: any;
    updatedOn: any;
    latitude: number;
    longitude: number;
    uid: string;
    id: string;
    followers: Array<Follower>;
    followerCount: number;
    phonePrefix: string;
    isPickupPoint: boolean;
    openDays: any;
    subCategory: string;
    type: string;
    isInvestmentRequired: string;
    investmentType: string;
    categorizedAs: string;
    reason: string;
    contractId: any;

    constructor() {
        this.id = "";
        this.title = "";
        this.description = "";
        this.whatsappNumber = "";
        this.urlHandle = "";
        this.images = new Array<string>();
        this.products = new Array<Product>();
        this.addressLine1 = "";
        this.addressLine2 = "";
        this.city = "";
        this.country = "";
        this.postalCode = "";
        this.category = "";
        this.currency = "usd";
        this.companyType = "";
        this.active = false;
        this.activeTill = null;
        this.createdOn = null;
        this.updatedOn = null;
        this.followers = new Array<Follower>();
        this.followerCount = 0;
        this.phonePrefix = "";
        this.isPickupPoint = false;
        this.openDays = null;
        this.subCategory = null;
        this.type = null;
        this.isInvestmentRequired = 'no';
        this.categorizedAs = null;
        this.reason = null;
        this.contractId = null;
    }
}

export class CompanyListModel {
    name: string;
    image: string;
    description: string;
    id: string;
    followerCount: number;
    category: string;
    subCategory: string;
    type: string;
    worth: number;
    categorizedAs: string;
    investmentType: Array<string>;
    country: string;
    city: string;
    downPayment: number;
}


// WEBPACK FOOTER //
// ./src/models/company.model.ts